// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"certificate"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4L22 20L2 20L2 4L22 4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M18 4L14 4L14 9.5L16 8L18 9.5L18 4Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 12H10M6 16H18M14 4L18 4V9.5L16 8L14 9.5L14 4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 4V20L2 20L2 4L22 4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CertificateIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'certificate',
    ref,
    icon: element,
  },
));

CertificateIcon.displayName = 'CertificateIcon';

export default CertificateIcon;
